import { LoadingState } from "../../../root-store/api-result.state";
import { SubscriptionActions } from "../actions";
import { initialSubscriptionState, SubscriptionState } from "../projects.state";

export const subscriptionReducer = (
    state: SubscriptionState = initialSubscriptionState,
    action: SubscriptionActions.Actions = null
): SubscriptionState => {
    switch (action.type) {
        case SubscriptionActions.ActionTypes.ClearActiveSubscription:
            return {
                ...state,
                activeSubscription: {
                    result: null,
                    callState: LoadingState.init,
                },
            };

        case SubscriptionActions.ActionTypes.ClearSubscriptions:
            return {
                ...state,
                subscriptions: {
                    result: null,
                    callState: LoadingState.init,
                },
            };

        case SubscriptionActions.ActionTypes.GetActiveSubscriptionByProjectId:
            return {
                ...state,
                activeSubscription: {
                    result: null,
                    callState: LoadingState.loading,
                },
            };
        case SubscriptionActions.ActionTypes.GetActiveSubscriptionByProjectIdSuccess:
            return {
                ...state,
                activeSubscription: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };

        case SubscriptionActions.ActionTypes.UpdateSubscriptionSuccess:
        case SubscriptionActions.ActionTypes.CreateSubscriptionSuccess: {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    result: {
                        ...state.subscriptions.result,
                        [action.result.subscription.id]: action.result.subscription,
                    },
                    callState: LoadingState.loaded,
                },
                activeSubscription: {
                    result: action.result.subscription,
                    callState: LoadingState.loaded,
                },
            };
        }

        case SubscriptionActions.ActionTypes.ConvertSubscriptionSuccess: {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    result: {
                        ...state.subscriptions.result,
                        [action.result.previous.id]: action.result.previous,
                        [action.result.current.id]: action.result.current,
                    },
                    callState: LoadingState.loaded,
                },
                activeSubscription: {
                    result: action.result.current,
                    callState: LoadingState.loaded,
                },
            };
        }

        default: {
            return state;
        }
    }
};
